import { FC, useState } from 'react';

import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import Iconify from '@src/components/iconify';
import useLocales from '@src/locales/use-locales';
import { NavSubGroupType } from '@src/types/main';

import NavItem from '../nav-item';

type NavSubGroupProps = {
  group: NavSubGroupType;
};

const NavSubGroup: FC<NavSubGroupProps> = (props) => {
  const { group } = props;

  const { t } = useLocales();

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
      <ListItemButton
        sx={{
          py: 1.5,
          pl: 5,
          pr: 2,
          gap: 2,
          '& .MuiListItemIcon-root': {
            minWidth: 'auto',
          },
        }}
        onClick={handleClick}
      >
        <ListItemIcon>
          <Iconify icon={group.icon} sx={{ color: 'custom.lightGrey' }} />
        </ListItemIcon>
        <ListItemText
          primary={group.subGroupLabel}
          slotProps={{
            primary: {
              sx: {
                fontFamily: 'secondaryFontFamily',
              },
            },
          }}
        />
        {open ? (
          <Iconify icon="mdi:expand-less" sx={{ color: 'custom.lightGrey' }} />
        ) : (
          <Iconify icon="mdi:expand-more" sx={{ color: 'custom.lightGrey' }} />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          aria-label={t('ariaLabels.subList')}
        >
          {group.entries.map((entry) => (
            <NavItem key={entry.id} item={entry} />
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default NavSubGroup;
